import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  wrapper: {
    bgcolor: capitalDesignTokens.foundations.colors.yellow100,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
  },
  innerWrapper: { display: "flex", alignItems: "center", paddingY: "8px" },
  migrateNowBtn: { marginLeft: "16px" },
  icon: { color: "#885604", marginRight: "4px", fontSize: "20px" },
  bannerText: { color: "#885604" },
});
